import { client } from '@/common-utils/libraries/axios/axios';
import { PUSH_PAYMENTS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateLabel = (onSuccess, onError) => {
    return {
        mutationFn: ({ pushPaymentNotifRuleId, label }) => {
            return client.put(replaceParameters(PUSH_PAYMENTS.NOTIF_RULES.UPDATE_LABEL.url, { pushPaymentNotifRuleId }), { label });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateLabel;